import { useEffect, useState } from "react";
import { ArrowUpRight, ArrowDownRight, Loader2 } from "lucide-react";
import { fetchMetalPrices } from "@/lib/api";

export default function PriceTicker() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const d = await fetchMetalPrices();
        if (alive) setData(d);
      } catch (e) {
        // silent fail – ticker just hides values
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    const id = setInterval(load, 90_000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const items = data
    ? [
        { label: "Gold Spot", value: `$${data.gold.usd_oz.toLocaleString("en-US")} / oz`, up: true },
        { label: "Silver Spot", value: `$${data.silver.usd_oz.toLocaleString("en-US")} / oz`, up: false },
        { label: "USD / INR", value: `₹${data.usd_inr}`, up: true },
      ]
    : [];

  return (
    <div data-testid="price-ticker" className="bg-[#0A0A0A] text-white border-b border-[#1a1a1a] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-9 flex items-center text-xs">
        <span className="uppercase tracking-[0.22em] text-[10px] text-[#D4AF37] font-semibold mr-6 shrink-0">Live Spot</span>
        {loading ? (
          <span className="flex items-center gap-2 text-white/60">
            <Loader2 className="w-3.5 h-3.5 animate-spin" /> Loading prices…
          </span>
        ) : (
          <div className="flex-1 overflow-hidden">
            <div className="marquee gap-10">
              {[...items, ...items].map((it, i) => (
                <span key={i} className="flex items-center gap-2 shrink-0">
                  <span className="text-white/60">{it.label}</span>
                  <span className="text-white font-medium">{it.value}</span>
                  {it.up ? (
                    <ArrowUpRight className="w-3.5 h-3.5 text-emerald-400" strokeWidth={2} />
                  ) : (
                    <ArrowDownRight className="w-3.5 h-3.5 text-rose-400" strokeWidth={2} />
                  )}
                  <span className="text-white/20 ml-8">/</span>
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
